export default "__VITE_PUBLIC_ASSET__369c02ee__"